import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { AndroidLoginContextProvider } from '@shared/lib/providers/android-login-context.provider';
import { IosLoginContextProvider } from '@shared/lib/providers/ios-login-context.provider';
import { AnalyticsService } from '@shared/lib/services/analytics.service';
import { LOGIN_CONTEXTS, LOGIN_INTERFACES } from '@shared/lib/shared-login.tokens';
import { SharedModule } from '@shared/lib/shared.module';
import { URL_SITE_DOMAIN } from '@usana/ux/common/url';
import {
  GRAPH_URL_MARKET,
  I18N_INFO_CONFIG,
  I18nHonorCookie,
  I18nInfoConfig,
  I18nOrganization,
  MarketActiveStatus,
  UsanaMarketsPreloadModule,
} from '@usana/ux/markets';
import { ID_TOKEN_NAME, LOGIN_APP_URL, LOGIN_REALM, LOGIN_SERVICE_URL } from '@usana/ux/sso-auth';
import { GRAPH_URL_TRANSLATION, REST_URL_TRANSLATION } from '@usana/ux/translations';
import { BaoyingRoutingModule } from './baoying-routing.module';
import { BaoyingAppComponent } from './components/app-root/baoying-app.component';
import { BaoyingFrLoginInterfaceMapper } from './models/baoying-fr-login-interface-mapper';
import { WechatMiniLoginContextProvider } from './providers/wechat-mini-login-context.provider';
import { SensordataAnalyticsService } from './services/sensordata-analytics.service';
import {
  DYNATRACE_MANUAL_PAGE_DETECTION,
  DYNATRACE_WINDOW_OBJ_POLL_RATE,
  SsoDynatraceModule,
} from '@usana/ux/dynatrace';

@NgModule({
  declarations: [BaoyingAppComponent],
  imports: [BrowserModule, UsanaMarketsPreloadModule, SharedModule, BaoyingRoutingModule, SsoDynatraceModule],
  providers: [
    { provide: ID_TOKEN_NAME, useValue: environment.lib.ssoIdToken },
    { provide: LOGIN_REALM, useValue: environment.lib.loginRealm },
    { provide: LOGIN_SERVICE_URL, useValue: environment.lib.loginServiceUrl },
    { provide: LOGIN_APP_URL, useValue: environment.lib.loginAppUrl },
    { provide: GRAPH_URL_TRANSLATION, useValue: `${environment.lib.i18nService}/graphql` },
    { provide: REST_URL_TRANSLATION, useValue: environment.lib.i18nService },
    { provide: GRAPH_URL_MARKET, useValue: `${environment.lib.i18nService}/graphql` },
    { provide: URL_SITE_DOMAIN, useValue: environment.app.domain },
    {
      provide: I18N_INFO_CONFIG,
      useFactory: () =>
        new I18nInfoConfig(
          false,
          false,
          true,
          false,
          true,
          false,
          false,
          false,
          MarketActiveStatus.ACTIVE,
          I18nOrganization.BAOYING,
          I18nHonorCookie.ALWAYS,
        ),
      multi: true,
    },
    { provide: LOGIN_INTERFACES, useValue: new BaoyingFrLoginInterfaceMapper() },
    {
      provide: LOGIN_CONTEXTS,
      useValue: [
        new WechatMiniLoginContextProvider(),
        new IosLoginContextProvider(),
        new AndroidLoginContextProvider(),
      ],
    },
    { provide: AnalyticsService, useClass: SensordataAnalyticsService },
    { provide: DYNATRACE_WINDOW_OBJ_POLL_RATE, useValue: 1000 },
    { provide: DYNATRACE_MANUAL_PAGE_DETECTION, useValue: true },
  ],
  bootstrap: [BaoyingAppComponent],
})
export class BaoyingModule {}
